import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const RUBSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M9.00021 3.50009H11.5188C13.4208 3.50018 14.9631 5.04238 14.9631 6.94443C14.963 8.81414 13.454 10.1963 11.5188 10.1964L7.84787 10.1954H7.34787V12.8624H10.1838C10.27 12.8624 10.34 12.9324 10.3401 13.0186C10.3401 13.1049 10.2701 13.1749 10.1838 13.1749H7.34787V16.3438C7.34776 16.43 7.27784 16.5001 7.19162 16.5001C7.10556 16.4999 7.03548 16.4299 7.03537 16.3438V13.1749H5.19357C5.10728 13.1749 5.03732 13.1049 5.03732 13.0186C5.03741 12.9324 5.10733 12.8624 5.19357 12.8624H7.03537V10.1964H5.19357C5.1073 10.1964 5.03735 10.1264 5.03732 10.0401C5.03732 9.95384 5.10728 9.88388 5.19357 9.88388H7.03537V5.48837C7.03537 4.40528 8.01053 3.50009 9.00021 3.50009ZM8.83224 3.79501C8.00389 3.79501 7.33235 4.46668 7.33224 5.29501V9.88779H11.5188C13.0956 9.8877 14.6514 8.61674 14.6516 6.94443C14.6516 6.11341 14.2601 5.3301 13.6965 4.76181C13.1328 4.19353 12.3525 3.79507 11.5188 3.79501H8.83224Z"
        stroke="#888888"
      />
    </svg>
  );
};
